import { Settings } from "../../../Settings";
import Character from "../../character/Character";
import GridTile from "../../grid/GridTile";
import PathPlan from "./PathPlan";

export default class PathPlanWalkLeft extends PathPlan {
    /**
     * @param {GridTile} startTile 
     * @param {GridTile} endTile 
     * @param {number} pathSteps
     */
    constructor(startTile, endTile, pathSteps) {
        super(startTile, endTile, pathSteps);
    }

    /**
     * @override
     * @param {Character} character 
     * @param {number} frameTimeRatio 
     * @param {boolean} turnStart True if this is the start of a turn.
     * @return {boolean} True when the step is completed.
     */
    executePlan(character, frameTimeRatio, turnStart) {

        const endTileCenterX = this.endTile.origin.x + Settings.tile.halfSize;
        const result = this.walkLeftToCenterX(character, frameTimeRatio, endTileCenterX);

        if (result) {
            this.assertEndTileReached(character, this.endTile);
        }

        return result;
    }
   
    /**
     * @returns {String}
     */
    toString() {
        return 'WalkLeft(' + this.pathSteps + ')';
    }
}